
const common = {
  // Navigation
  home: 'الرئيسية',
  about: 'من نحن',
  services: 'خدماتنا',
  contact: 'اتصل بنا',
  events: 'الفعاليات',
  licenses: 'التراخيص',
  
  // Hero Section
  heroTitle: 'بوابتك لنجاح مهني في دول الخليج',
  heroSubtitle: 'خدمات التوظيف المهنية لقطر وعمان والكويت والسعودية والإمارات',
  heroDescription: 'مع أكثر من 15 عاماً من الخبرة، نربط المهنيين المهرة بأفضل أصحاب العمل في منطقة الخليج. من الرعاية الصحية إلى البناء، ومن الضيافة إلى التكنولوجيا - نحقق أحلامك المهنية في دول الخليج.',
  getStarted: 'ابدأ الآن',
  learnMore: 'اعرف المزيد',
  
  // Trust Indicators
  trustedBy: 'موثوق من قبل',
  gccEmployers: 'كبار أصحاب العمل في الخليج',
  certifiedAgency: 'وكالة معتمدة',
  qualityAssured: 'جودة مضمونة',
  
  // Stats
  yearsExperience: 'سنة خبرة',
  successfulPlacements: 'توظيف ناجح',
  partnerCompanies: 'شركة شريكة',
  countries: 'دول خليجية',
  
  // About Section
  aboutTitle: 'حول بيشا ترافيلز',
  aboutSubtitle: 'شريكك الموثوق لفرص العمل في دول الخليج',
  aboutDescription: 'بيشا ترافيلز هي وكالة توظيف رائدة متخصصة في دول الخليج لأكثر من 15 عاماً. لقد نجحنا في توظيف آلاف المهنيين المهرة في قطاعات مختلفة بما في ذلك الرعاية الصحية والبناء والضيافة والتكنولوجيا عبر قطر وعمان والكويت والسعودية والإمارات.',
  ourMission: 'مهمتنا',
  missionText: 'سد الفجوة بين المهنيين الموهوبين وأصحاب العمل الرائدين في منطقة الخليج، مما يضمن النجاح المتبادل والشراكات طويلة الأمد.',
  ourVision: 'رؤيتنا',
  visionText: 'أن نكون الشريك الأكثر ثقة وتفضيلاً للتوظيف في دول الخليج، معروفين بنزاهتنا وجودة خدماتنا وتوظيفاتنا الناجحة.',
  
  // Services
  servicesTitle: 'خدماتنا',
  servicesSubtitle: 'حلول توظيف شاملة لدول الخليج',
  hospitalityTitle: 'الضيافة والسياحة',
  hospitalityDesc: 'تواصل مع الفنادق والمنتجعات وشركات السياحة الرائدة في منطقة الخليج.',
  constructionTitle: 'البناء والهندسة',
  constructionDesc: 'اعثر على فرص في مشاريع البنية التحتية والبناء الكبرى في دول الخليج.',
  medicalTitle: 'الرعاية الصحية والطبية',
  medicalDesc: 'انضم إلى أفضل المستشفيات والمرافق الصحية في قطر والإمارات والسعودية والكويت وعمان.',
  technicalTitle: 'التقنية وتكنولوجيا المعلومات',
  technicalDesc: 'استكشف فرص التكنولوجيا وتقنية المعلومات في قطاع التكنولوجيا سريع النمو في الخليج.',
  
  // Documentation
  documentationTitle: 'دعم الوثائق',
  documentationList: [
    'استشارة أولية وتقييم المهارات',
    'مطابقة الوظائف مع أصحاب العمل المعتمدين في الخليج',
    'إعداد ومراجعة عقد العمل',
    'دعم طلب ومعالجة التأشيرة',
    'تنسيق الفحص الطبي',
    'ترتيبات السفر وإحاطة ما قبل المغادرة'
  ],
  
  // Contact
  contactTitle: 'اتصل بنا',
  contactSubtitle: 'تواصل مع فريق التوظيف ذو الخبرة',
  contactDescription: 'مستعد لبدء رحلتك المهنية في الخليج؟ فريقنا هنا لإرشادك خلال كل خطوة من العملية.',
  contactInfo: 'معلومات الاتصال',
  fullName: 'الاسم الكامل',
  emailAddress: 'عنوان البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  subject: 'الموضوع',
  message: 'الرسالة',
  sendMessage: 'إرسال الرسالة',
  
  // Contact Details
  phoneLabel: 'الهاتف',
  emailLabel: 'البريد الإلكتروني',
  addressLabel: 'العنوان',
  phone1: '+91 98954 40243',
  phone2: '+91 80788 80074',
  email1: 'bdm@bichatravels.com',
  email2: 'mail@bichatravels.com',
  
  // Office Addresses - Updated with actual addresses
  officeAddress1: 'باب رقم 61/849، الطابق الثاني، مجمع P.K، طريق شيروتي، كاليكوت، كيرالا، الهند- 673032',
  officeAddress2: 'الطابق الثاني، مجمع Kmi، بالقرب من عمود المترو 193، موتوم، كوتشين، كيرالا',
  officeAddress3: 'الطابق الرابع، أبراج اللؤلؤ، مقابل فندق كراون بلازا، شارع المطار، أم غويلينا، الدوحة، قطر',
  officeAddress4: 'مدينة الكويت، المرقاب بالقرب من هايبر ماركت نستو، مدينة الكويت، الكويت',
  
  // Offices
  ourOffices: 'مكاتبنا',
  headOffice: 'المكتب الرئيسي',
  branchOffice: 'مكتب الفرع',
  branchOffice2: 'مكتب الفرع',
  branchOffice3: 'مكتب الفرع',
  
  // Licenses
  licensesTitle: 'التراخيص والشهادات',
  licensesSubtitle: 'وكالة توظيف مرخصة ومعتمدة بالكامل',
  licenseNumber1: 'B-1701/KER/PER/1000+/5/9853/2021',
  licenseNumber2: 'MHA-2024-002',
  licenseNumber3: 'MHA-2024-003',
  
  // Footer
  quickLinks: 'روابط سريعة',
  followUs: 'تابعنا',
  allRightsReserved: 'جميع الحقوق محفوظة.',
  
  // Common Actions
  // contact: 'اتصل بنا',
  readMore: 'اقرأ المزيد',
  viewAll: 'عرض الكل'
};

export default common;